var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEternalTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 148.62 131.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#_1248-4);}.cls-2{fill:url(#_1248-3);}.cls-3{fill:url(#_1248-2);}.cls-4{fill:url(#_1321-3);}.cls-5{fill:url(#_1321-4);}.cls-6{fill:url(#_1321-2);}.cls-7{fill:url(#_1321-6);}.cls-8{fill:url(#_1321-5);}.cls-9{fill:url(#_236-12);}.cls-10{fill:url(#_236-11);}.cls-11{fill:url(#_236-16);}.cls-12{fill:url(#_236-10);}.cls-13{fill:url(#_236-15);}.cls-14{fill:url(#_236-14);}.cls-15{fill:url(#_236-13);}.cls-16{fill:url(#linear-gradient);}.cls-17{fill:url(#_127-2);}.cls-17,.cls-18,.cls-19{mix-blend-mode:color-dodge;}.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30{opacity:.5;}.cls-18{fill:url(#_127-3);}.cls-31{fill:url(#_236);}.cls-19{fill:url(#_127);}.cls-32{fill:url(#_1321);}.cls-33{fill:url(#_1248);}.cls-34{fill:url(#New_Gradient_Swatch_5);}.cls-20{fill:url(#New_Gradient_Swatch_1);}.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30{mix-blend-mode:multiply;}.cls-35{fill:url(#linear-gradient-2);}.cls-21{fill:url(#New_Gradient_Swatch_1-10);}.cls-22{fill:url(#New_Gradient_Swatch_1-11);}.cls-23{fill:url(#New_Gradient_Swatch_1-6);}.cls-24{fill:url(#New_Gradient_Swatch_1-9);}.cls-25{fill:url(#New_Gradient_Swatch_1-7);}.cls-26{fill:url(#New_Gradient_Swatch_1-4);}.cls-27{fill:url(#New_Gradient_Swatch_1-3);}.cls-28{fill:url(#New_Gradient_Swatch_1-8);}.cls-29{fill:url(#New_Gradient_Swatch_1-5);}.cls-30{fill:url(#New_Gradient_Swatch_1-2);}.cls-36{isolation:isolate;}.cls-37{fill:url(#_236-9);}.cls-38{fill:url(#_236-7);}.cls-39{fill:url(#_236-6);}.cls-40{fill:url(#_236-5);}.cls-41{fill:url(#_236-4);}.cls-42{fill:url(#_236-8);}.cls-43{fill:url(#_236-3);}.cls-44{fill:url(#_236-2);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_5",
    cx: 70.36,
    cy: 68.65,
    fx: -1.03,
    fy: 6.82,
    r: 110.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#f1eff1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#c7c2ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#a198a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#817587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#66576e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#503e59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3e2c48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#331e3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2c1736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a1535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236",
    x1: 74.31,
    y1: 0,
    x2: 74.31,
    y2: 131.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9e0ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#98aad2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7671a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    x1: 74.31,
    y1: 83.91,
    x2: 74.31,
    y2: 131.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d7cba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a5ba4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-2",
    x1: 74.31,
    y1: 129.92,
    x2: 74.31,
    y2: 1.93,
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_127",
    x1: 74.31,
    y1: -3960.5,
    x2: 74.31,
    y2: -3912.56,
    gradientTransform: "translate(0 -3912.56) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d7cba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#acbcdd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-2",
    x1: 23.79,
    y1: 64.8,
    x2: 23.79,
    y2: 86.3,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321",
    x1: -5637.39,
    y1: 1031.1,
    x2: -5637.39,
    y2: 1011.11,
    gradientTransform: "translate(-1738.34 5475.8) rotate(118.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#85769c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#98aad2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9e0ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-3",
    x1: -5634.94,
    y1: 1009.28,
    x2: -5634.94,
    y2: 1027,
    gradientTransform: "translate(-1738.34 5475.8) rotate(118.16)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-4",
    x1: -5651.16,
    y1: 1013.8,
    x2: -5651.16,
    y2: 1020.14,
    gradientTransform: "translate(-1738.34 5475.8) rotate(118.16)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_127-2",
    x1: -5656.56,
    y1: 1022.33,
    x2: -5656.56,
    y2: 1017.07,
    gradientTransform: "translate(-1738.34 5475.8) rotate(118.16)",
    xlinkHref: "#_127"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248",
    x1: -5652.25,
    y1: 1002.41,
    x2: -5652.25,
    y2: 1008.94,
    gradientTransform: "translate(-1738.34 5475.8) rotate(118.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a5ba4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1f3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-3",
    x1: -5621.71,
    y1: 1017.07,
    x2: -5621.71,
    y2: 1015.54,
    gradientTransform: "translate(-1738.34 5475.8) rotate(118.16)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-5",
    x1: 4.83,
    y1: 57.22,
    x2: 0.44,
    y2: 65.9,
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-2",
    x1: -10028.73,
    y1: 3381.42,
    x2: -10028.73,
    y2: 3361.43,
    gradientTransform: "translate(-1738.34 -10324.9) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-6",
    x1: -10026.28,
    y1: 3359.59,
    x2: -10026.28,
    y2: 3377.32,
    gradientTransform: "translate(-1738.34 -10324.9) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-7",
    x1: -10042.49,
    y1: 3363.96,
    x2: -10042.49,
    y2: 3370.5,
    gradientTransform: "translate(-1738.34 -10324.9) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-8",
    x1: -10047.9,
    y1: 3372.64,
    x2: -10047.9,
    y2: 3367.38,
    gradientTransform: "translate(-1738.34 -10324.9) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248-2",
    x1: -10043.2,
    y1: 3353.18,
    x2: -10043.2,
    y2: 3359.6,
    gradientTransform: "translate(-1738.34 -10324.9) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#_1248"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-4",
    x1: -10013.05,
    y1: 3367.39,
    x2: -10013.05,
    y2: 3365.85,
    gradientTransform: "translate(-1738.34 -10324.9) rotate(-118.16) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-9",
    x1: -0.18,
    y1: 81.87,
    x2: 5.98,
    y2: 77.39,
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-3",
    x1: 19.46,
    y1: 71.54,
    x2: 3.04,
    y2: 59.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-5",
    x1: 10.82,
    y1: 58.22,
    x2: 10.82,
    y2: 72.25,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-6",
    x1: 10.82,
    y1: 21.03,
    x2: 10.82,
    y2: 35.06,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-7",
    x1: -4207.29,
    y1: 64.8,
    x2: -4207.29,
    y2: 86.3,
    gradientTransform: "translate(-4082.46) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-4",
    x1: -3640.91,
    y1: 4761.33,
    x2: -3640.91,
    y2: 4741.34,
    gradientTransform: "translate(-2344.12 5475.8) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-10",
    x1: -3638.46,
    y1: 4739.51,
    x2: -3638.46,
    y2: 4757.23,
    gradientTransform: "translate(-2344.12 5475.8) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-11",
    x1: -3654.68,
    y1: 4744.03,
    x2: -3654.68,
    y2: 4750.37,
    gradientTransform: "translate(-2344.12 5475.8) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_127-3",
    x1: -3660.08,
    y1: 4752.56,
    x2: -3660.08,
    y2: 4747.3,
    gradientTransform: "translate(-2344.12 5475.8) rotate(61.84) scale(1 -1)",
    xlinkHref: "#_127"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248-3",
    x1: 95.21,
    y1: 18.66,
    x2: 118.73,
    y2: 12.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#_1248"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-8",
    x1: -3625.23,
    y1: 4747.3,
    x2: -3625.23,
    y2: 4745.77,
    gradientTransform: "translate(-2344.12 5475.8) rotate(61.84) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-12",
    x1: -4226.25,
    y1: 57.22,
    x2: -4230.64,
    y2: 65.9,
    gradientTransform: "translate(-4082.46) rotate(-180) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-5",
    x1: -8032.25,
    y1: 7111.65,
    x2: -8032.25,
    y2: 7091.66,
    gradientTransform: "translate(-2344.12 -10324.9) rotate(-61.84)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-13",
    x1: -8029.8,
    y1: 7089.82,
    x2: -8029.8,
    y2: 7107.55,
    gradientTransform: "translate(-2344.12 -10324.9) rotate(-61.84)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-14",
    x1: -8046.01,
    y1: 7094.2,
    x2: -8046.01,
    y2: 7100.73,
    gradientTransform: "translate(-2344.12 -10324.9) rotate(-61.84)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-15",
    x1: -8051.42,
    y1: 7102.87,
    x2: -8051.42,
    y2: 7097.61,
    gradientTransform: "translate(-2344.12 -10324.9) rotate(-61.84)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1248-4",
    x1: -8046.72,
    y1: 7083.42,
    x2: -8046.72,
    y2: 7089.83,
    gradientTransform: "translate(-2344.12 -10324.9) rotate(-61.84)",
    xlinkHref: "#_1248"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-9",
    x1: -8016.57,
    y1: 7097.62,
    x2: -8016.57,
    y2: 7096.08,
    gradientTransform: "translate(-2344.12 -10324.9) rotate(-61.84)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_236-16",
    x1: -4231.26,
    y1: 81.87,
    x2: -4225.1,
    y2: 77.39,
    gradientTransform: "translate(-4082.46) rotate(-180) scale(1 -1)",
    xlinkHref: "#_236"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_1321-6",
    x1: -4211.62,
    y1: 71.54,
    x2: -4228.05,
    y2: 59.97,
    gradientTransform: "translate(-4082.46) rotate(-180) scale(1 -1)",
    xlinkHref: "#_1321"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-10",
    x1: -4220.26,
    y1: 58.22,
    x2: -4220.26,
    y2: 72.25,
    gradientTransform: "translate(-4082.46) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-11",
    x1: -4220.26,
    y1: 21.03,
    x2: -4220.26,
    y2: 35.06,
    gradientTransform: "translate(-4082.46) rotate(-180) scale(1 -1)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 30.76,
    y1: 65.6,
    x2: 124.38,
    y2: 67.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#17a638"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ac554"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 23.15,
    y1: 66.34,
    x2: 117.84,
    y2: 66.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#29a737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007134"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 74.31,
    cy: 66.36,
    r: 63.55
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m74.32,0C37.9,0,8.39,29.52,8.39,65.93s29.52,65.93,65.93,65.93,65.93-29.52,65.93-65.93S110.73,0,74.32,0Zm0,128.16c-16.62,0-32.25-6.47-44-18.23-11.76-11.76-18.23-27.38-18.23-44.01s6.47-32.25,18.23-44C42.06,10.17,57.69,3.69,74.32,3.69s32.25,6.47,44,18.23c11.76,11.76,18.23,27.38,18.23,44s-6.47,32.25-18.23,44.01c-11.75,11.75-27.38,18.23-44,18.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m74.32,130.05c-29.77,0-54.97-19.4-63.44-46.14,7.83,27.67,33.27,47.94,63.44,47.94s55.61-20.27,63.44-47.94c-8.48,26.74-33.67,46.14-63.44,46.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m119.57,20.67C107.48,8.58,91.41,1.93,74.32,1.93s-33.16,6.66-45.25,18.75c-12.09,12.09-18.74,28.16-18.74,45.25s6.66,33.16,18.74,45.25c12.09,12.09,28.16,18.74,45.25,18.74s33.17-6.66,45.25-18.74c12.09-12.09,18.74-28.16,18.74-45.25s-6.66-33.17-18.74-45.25Zm-1.25,89.26c-11.75,11.75-27.38,18.23-44,18.23s-32.25-6.47-44-18.23c-11.76-11.76-18.23-27.38-18.23-44.01s6.47-32.25,18.23-44C42.06,10.17,57.69,3.69,74.32,3.69s32.25,6.47,44,18.23c11.76,11.76,18.23,27.38,18.23,44s-6.47,32.25-18.23,44.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m137.76,47.94C129.93,20.27,104.49,0,74.32,0S18.7,20.27,10.87,47.94C19.35,21.2,44.55,1.99,74.32,1.99s54.97,19.21,63.44,45.95Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m21.11,98.93l1.72,5.03s.43,1.37-.28,2.8l3.93,4.53-.52-6.18-4.85-6.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m26.96,18.03c-2.91,9.79-7.21,17.51-7.21,17.51-.98,2.17-2.33,5.08-2.33,5.08-.57,1.24-1.56,3.84-1.56,3.84,2.82-3.12,4.66-5.85,6.82-8.67,4.17-5.45,7.01-15.06,8.4-20.66.65-2.63.99-4.37.99-4.37,2.42-1.17,3.7-1.9,3.85-1.98.22-.11.45-.21.67-.31-.99-1.3-2.2-2.27-2.2-2.27-3.74-.56-5.28,1.48-5.28,1.48-.23,1.88-.54,3.7-.91,5.44-.37,1.72-.79,3.36-1.26,4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m17.43,40.62s2.11-4.66,2.25-4.9c0,0,4.38-7.9,7.29-17.69.46-1.56.89-3.2,1.26-4.91,0,0,.75,13.06-10.79,27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m31.39,15.89s-.45.46-1.8,4.68c0,0,.46-5.89,1.99-10.6,0,0,1.6-2.99,2.85-3.75.19.16,1.72,1.19,3.97,4.41-.22.1-.91.64-1.13.75-.15.09-2.43,1.73-5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m29.13,7.68s1.33-1.77,4.52-1.57c-1.36,1.86-3.95,2.3-4.52,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m31.39,15.89l.97-2.77c1.29-1.73,2.77-2.63,2.77-2.63,0,0,1.31.19,2.57.62l-.42.28c-3.05,2.01-5.88,4.51-5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m18.15,41.78s.83-2.07,1.43-3.99l.85-3.5c-.12.15-.52,1.06-.67,1.24-1.61,3.22-2.54,5.26-3.89,8.92,0,0,1.64-1.96,2.28-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m10.32,50.03s-4.56,4.81-7.29,15.9H0s.72-12.21,12.37-22.62l-2.05,6.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m26.96,113.82c-2.91-9.79-7.21-17.51-7.21-17.51-.98-2.17-2.33-5.08-2.33-5.08-.57-1.24-1.56-3.84-1.56-3.84,2.82,3.12,4.66,5.85,6.82,8.67,4.17,5.45,7.01,15.06,8.4,20.66.65,2.63.99,4.37.99,4.37,2.42,1.17,3.7,1.9,3.85,1.98.22.11.45.21.67.31-.99,1.3-2.2,2.27-2.2,2.27-3.74.56-5.28-1.48-5.28-1.48-.23-1.88-.54-3.7-.91-5.44-.37-1.72-.79-3.36-1.26-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m17.43,91.24s2.11,4.66,2.25,4.9c0,0,4.38,7.9,7.29,17.69.46,1.56.89,3.2,1.26,4.91,0,0,.75-13.06-10.79-27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m31.05,115.61s-.11-.11-1.46-4.33c0,0,.46,5.89,1.99,10.6,0,0,1.6,2.99,2.85,3.75.19-.16,3.4-3.02,4.3-4.2-.22-.1-1.69-1.17-1.91-1.28-.15-.09-2.9-1.86-5.77-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m29.13,124.17s1.33,1.77,4.52,1.57c-1.36-1.86-3.95-2.3-4.52-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m31.05,115.61l.82,2.29c.61,2.08,2.11,3.67,2.11,3.67,0,0,1.06.22,2.01-.28l1.2-.89c-.61-.33-4.12-3.04-6.15-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m18.15,90.07s.83,2.07,1.43,3.99l.85,3.5c-.12-.15-.52-1.06-.67-1.24-1.61-3.22-2.54-5.26-3.89-8.92,0,0,1.64,1.96,2.28,2.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m10.32,81.82s-4.56-4.81-7.29-15.9H0s.72,12.21,12.37,22.62l-2.05-6.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m3.03,65.93c2.59-10.81,7.29-15.9,7.29-15.9l1.17-3.85C2.86,54.36,1.46,65.93,1.46,65.93c0,0,1.4,11.57,10.03,19.74l-1.17-3.85s-4.7-5.09-7.29-15.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m9.27,80.49s.36,2.19.3,3.18l.74,2.91,2.05,1.97-.88-2.88-1.17-3.85-1.05-1.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "12.37 43.3 11.49 46.18 10.32 50.03 9.27 51.36 9.27 48.53 11.49 44.11 12.37 43.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m127.52,98.93l-1.72,5.03s-.43,1.37.28,2.8l-3.93,4.53.52-6.18,4.85-6.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m121.66,18.03c2.91,9.79,7.21,17.51,7.21,17.51.98,2.17,2.33,5.08,2.33,5.08.57,1.24,1.56,3.84,1.56,3.84-2.82-3.12-4.66-5.85-6.82-8.67-4.17-5.45-7.01-15.06-8.4-20.66-.65-2.63-.99-4.37-.99-4.37-2.42-1.17-3.7-1.9-3.85-1.98-.22-.11-.45-.21-.67-.31.99-1.3,2.2-2.27,2.2-2.27,3.74-.56,5.28,1.48,5.28,1.48.23,1.88.54,3.7.91,5.44.37,1.72.79,3.36,1.26,4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m131.2,40.62s-2.11-4.66-2.25-4.9c0,0-4.38-7.9-7.29-17.69-.46-1.56-.89-3.2-1.26-4.91,0,0-.75,13.06,10.79,27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m117.24,15.89s.45.46,1.8,4.68c0,0-.46-5.89-1.99-10.6,0,0-1.6-2.99-2.85-3.75-.19.16-1.72,1.19-3.97,4.41.22.1.91.64,1.13.75.15.09,2.43,1.73,5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m119.5,7.68s-1.33-1.77-4.52-1.57c1.36,1.86,3.95,2.3,4.52,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m117.24,15.89l-.97-2.77c-1.29-1.73-2.77-2.63-2.77-2.63,0,0-1.31.19-2.57.62l.42.28c3.05,2.01,5.88,4.51,5.88,4.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m130.48,41.78s-.83-2.07-1.43-3.99l-.85-3.5c.12.15.52,1.06.67,1.24,1.61,3.22,2.54,5.26,3.89,8.92,0,0-1.64-1.96-2.28-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m138.31,50.03s4.56,4.81,7.29,15.9h3.03s-.72-12.21-12.37-22.62l2.05,6.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m121.66,113.82c2.91-9.79,7.21-17.51,7.21-17.51.98-2.17,2.33-5.08,2.33-5.08.57-1.24,1.56-3.84,1.56-3.84-2.82,3.12-4.66,5.85-6.82,8.67-4.17,5.45-7.01,15.06-8.4,20.66-.65,2.63-.99,4.37-.99,4.37-2.42,1.17-3.7,1.9-3.85,1.98-.22.11-.45.21-.67.31.99,1.3,2.2,2.27,2.2,2.27,3.74.56,5.28-1.48,5.28-1.48.23-1.88.54-3.7.91-5.44.37-1.72.79-3.36,1.26-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m131.2,91.24s-2.11,4.66-2.25,4.9c0,0-4.38,7.9-7.29,17.69-.46,1.56-.89,3.2-1.26,4.91,0,0-.75-13.06,10.79-27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m117.58,115.61s.11-.11,1.46-4.33c0,0-.46,5.89-1.99,10.6,0,0-1.6,2.99-2.85,3.75-.19-.16-3.4-3.02-4.3-4.2.22-.1,1.69-1.17,1.91-1.28.15-.09,2.9-1.86,5.77-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m119.5,124.17s-1.33,1.77-4.52,1.57c1.36-1.86,3.95-2.3,4.52-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m117.58,115.61l-.82,2.29c-.61,2.08-2.11,3.67-2.11,3.67,0,0-1.06.22-2.01-.28l-1.2-.89c.61-.33,4.12-3.04,6.15-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m130.48,90.07s-.83,2.07-1.43,3.99l-.85,3.5c.12-.15.52-1.06.67-1.24,1.61-3.22,2.54-5.26,3.89-8.92,0,0-1.64,1.96-2.28,2.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m138.31,81.82s4.56-4.81,7.29-15.9h3.03s-.72,12.21-12.37,22.62l2.05-6.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m145.6,65.93c-2.59-10.81-7.29-15.9-7.29-15.9l-1.17-3.85c8.63,8.18,10.03,19.74,10.03,19.74,0,0-1.4,11.57-10.03,19.74l1.17-3.85s4.7-5.09,7.29-15.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m139.35,80.49s-.36,2.19-.3,3.18l-.74,2.91-2.05,1.97.88-2.88,1.17-3.85,1.04-1.33Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "136.25 43.3 137.13 46.18 138.31 50.03 139.35 51.36 139.35 48.53 137.13 44.11 136.25 43.3"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m101.68,25.15c-5.89-3.38-12.2-5.35-18.54-6.03,4.7.92,9.33,2.61,13.71,5.13,21.44,12.31,28.84,39.67,16.53,61.11-1.73,3.01-3.75,5.74-6.01,8.18-.7.73-1.41,1.43-2.12,2.08-18.26,15.92-36.42,1.62-39.29-4.75-.35-.78-.66-1.56-.95-2.35,5.43-2.68,11.28-5.95,18.95-6.7,11.33-1.1,19.94,7.93,19.94,7.93,0,0-5.76-9.32-16.03-11.47-9.88-2.06-16.13,1.59-24.42,4.36-.03-.16-.06-.32-.08-.47.93-5.43,3.75-11.91,11.51-14.76,0,0-7.92,4.83-8.61,11.04,0,0,5.01,1.78,8.26-4.31,3.25-6.09,5.71-6.68,7.59-6.21,0,0-10.92-7.07-17.57,4.05-.68,1.14-1.18,2.37-1.55,3.64.31-7.01,2.88-13.7,7.52-18.92,3.96-2.56,9.8-4.65,16.14-1.22,0,0-7.45-2.31-11.76.71,0,0,1.66,4.15,7.32,2.82,5.65-1.34,7.39-.11,8.14,1.34,0,0-1.61-10.83-12.33-8.83-.9.17-1.77.44-2.61.8,1.16-.83,2.4-1.59,3.72-2.26,3.73-1.91,7.67-2.96,11.6-3.25.72.73,2.39,2.19,4.34,2.19,2.61,0,4.72-2.6,4.72-2.6,0,0-2.11-2.6-4.72-2.6s-4.72,2.6-4.72,2.6c0,0,0,0,0,0-3.33.03-6.69.58-9.95,1.7,1-.85,1.89-1.83,2.55-2.97,4.52-7.83-3.49-12.08-3.49-12.08.93.99,1.4,2.68-1.2,6.73-2.61,4.05.18,6.49.18,6.49,3.55-2.53,3.8-8.99,3.8-8.99.93,5.93-2.34,9.92-5.44,12.3-.21.1-.41.19-.62.3-1.35.69-2.62,1.47-3.83,2.32-.29.13-.46.19-.46.19,0,0,.11-.03.32-.09-3.66,2.6-6.63,5.89-8.84,9.58-.05-2.38-.4-4.76-1.22-7-5.95-16.34-22.11-9.78-22.11-9.78,2.6-.14,5.69,1.25,8.43,10.09,2.74,8.85,9.79,7.76,9.79,7.76.65-8.36-8.55-16.72-8.55-16.72,8.61,5.19,11.12,13.25,11.4,20.22-2.16,5.45-2.83,11.47-1.76,17.39-1.11.28-2.27.54-3.48.76-12.65,2.24-24.04-8.18-24.04-8.18,2.78,12.56,10.63,23.96,22.67,30.87,15.53,8.91,33.98,8.06,48.27-.64,0,0,0,0,.01,0h0c6.58-4.01,12.28-9.69,16.39-16.85,13.03-22.69,5.19-51.64-17.49-64.67Zm-56.15,65.33c5.91,2.75,10.77,1.84,15.7-.22.34.83.71,1.65,1.12,2.45,2.63,5.15,5.62,9.31,9.19,12.29-15.43-2.87-26.01-14.53-26.01-14.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m117.84,64.87c-.22-6.37-1.73-12.81-4.67-18.93-2.38-4.95-5.52-9.29-9.19-12.97-.11-.11-.22-.21-.32-.32-.1-.1-.2-.2-.3-.3-2.84-2.77-6.07-5.21-9.67-7.23-6.71-3.76-13.98-5.7-21.23-5.97-.25-.01-.49-.02-.74-.02-.05,0-.09,0-.14,0-7.46-.18-15.08,1.41-22.25,4.98-3.59,1.79-6.86,3.99-9.77,6.51-3.78,3.25-7.1,7.16-9.77,11.66-4.48,7.55-6.61,15.83-6.64,24-.05,6.83,1.37,13.76,4.45,20.32,5.17,11.02,14.14,19.2,24.78,23.61.08.03.17.07.25.11.21.09.43.17.64.26.19.08.39.15.58.23.13.05.27.1.41.15.26.1.53.19.79.29.1.04.21.07.31.11.29.1.57.19.86.28.13.04.26.08.39.12.25.08.5.15.75.23.05.01.1.03.14.04,0,0,0,0,0,0,2.63.75,5.3,1.27,7.97,1.56-4.87-.95-9.66-2.74-14.19-5.42-1.52-.93-3.17-2-4.75-3.22-.06-.05-.13-.1-.19-.15-.08-.07-.17-.13-.25-.2-.21-.17-.41-.34-.62-.51-.78-.65-1.53-1.32-2.25-2-.03-.03-.06-.06-.09-.08-.36-.35-.72-.69-1.06-1.05-.01-.01-.02-.02-.03-.04-.3-.31-.59-.62-.88-.93-.1-.11-.21-.23-.31-.34-.21-.24-.42-.48-.63-.72-.09-.11-.18-.21-.28-.32-.27-.32-.53-.64-.79-.97-.09-.11-.18-.23-.27-.34-.23-.29-.45-.58-.67-.87-.04-.05-.08-.11-.12-.16-2.63-3.59-4.67-7.53-6.23-11.82-.51-1.46-.95-2.95-1.31-4.46-.74-3.24-1.18-6.95-1.23-11.21.12-7.3,2.01-14.65,5.86-21.38,1.74-3.03,3.77-5.79,6.05-8.24,1.21-1.26,2.44-2.41,3.68-3.47.14-.12.29-.24.43-.35,1.54-1.21,3.19-2.45,4.93-3.58,3.09-1.93,6.23-3.36,9.32-4.37.2-.07.41-.13.61-.19.06-.02.12-.04.17-.05,4.84-1.46,9.8-2.04,14.68-1.82.09,0,.19,0,.28.01.06,0,.13,0,.19.01,1.75.16,3.31.32,4.78.53,3.89.64,7.69,1.8,11.29,3.42,7.42,3.5,13.19,8.14,18.21,14.95,1.24,1.75,2.38,3.6,3.38,5.56,2.5,4.86,4.01,9.96,4.63,15.07Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEternalTree);
export default __webpack_public_path__ + "static/media/eternal-tree.2188adbee457296d1776e3271ff047a5.svg";
export { ForwardRef as ReactComponent };